export default {"src":"/_next/static/media/pregnancy-test.2fd1dc07.svg","height":361,"width":1154};